import { useCart } from '@order/hooks';

import type { CheckoutPayload } from '../../Checkout.utils';
import { calculateTip } from '../../Checkout.utils';

export const useDeliveryTip = (payload: CheckoutPayload) => {
  const { cart } = useCart();

  return (
    payload?.deliveryOrderDetail?.tip ??
    calculateTip(cart?.ledger?.subtotal) ??
    0
  );
};
